"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECorporationFormeJuridiqueTrads = void 0;
exports.ECorporationFormeJuridiqueTrads = {
    association: "Association",
    congregation: "Congrégation",
    EARL: "EARL",
    EI: "Entreprise individuelle",
    fondation: "Fondation",
    SA: "Société anonyme",
    SARL: "Société à responsabilité limitée",
    SAS: "Société par action simplifiée",
    SASU: "Société par action simplifiée unipersonnelle",
    SC: "Société civile",
    SCI: "Société civile immobilière",
    SCP: "Société civile de professionnels",
    SCS: "Société en commandite simple",
    SEL: "Société d'exercice libéral",
    SELARL: "Société d'exercice libéral à responsabilité limitée",
    SNC: "Société en nom collectif",
    SCCV: "Société civile de export construction vente",
    SCM: "Société civile de moyens",
    SELAS: "Société d'exercice libéral par actions simplifiée",
    other: "Autre",
};
